export var WebMobileMode = {
  homescreen: 'pwa_homescreen',
  browser: 'pwa_browser'
};
export var Platform = {
  mobile: 'web_mobile',
  tablet: 'web_tablet',
  desktop: 'web_desktop',
  twa: 'android'
};
export var TrackingServices = {
  amplitude: 'amplitude',
  gtm: 'GTM',
  braze: 'braze',
  appCues: 'appCues',
  snowplow: 'snowplow'
};
export var allTrackingServices = Object.values(TrackingServices);
export var brazeSdkEndpoint = 'https://customer.iad-03.braze.com/api/v3';
export var OMITTED_PROPERTY_PATTERNS = {
  amplitude: [],
  gtm: [],
  appCues: [],
  snowplow: [],
  braze: [/^aa[_-]/, /^ab[_-]/, /^abc[_-]/, /^abcd[_-]/, /^example_test$/, /^offer_api_experiment$/, /^offer_api_experiment_test$/, /^twabrowserpackage$/, /^twabrowserversioncode$/, /^twabrowserversionname$/, /^twaversion$/, /^versionName$/, /^web_mobile_mode$/]
};